import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import api from '../../services/api';
import '../../styles/auth.css';

function isStrongPassword(pwd) {
  if (pwd.length < 8) return 'Пароль должен содержать минимум 8 символов';
  if (!/[A-Z]/.test(pwd)) return 'Пароль должен содержать заглавную букву';
  if (!/[a-z]/.test(pwd)) return 'Пароль должен содержать строчную букву';
  if (!/\d/.test(pwd)) return 'Пароль должен содержать цифру';
  if (!/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(pwd)) return 'Пароль должен содержать спецсимвол';
  return null;
}

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setSuccess('');

    if (!token) { setError('Неверная ссылка сброса пароля'); return; }
    const pwdError = isStrongPassword(password);
    if (pwdError) { setError(pwdError); return; }
    if (password !== confirmPassword) { setError('Пароли не совпадают'); return; }

    setLoading(true);
    try {
      const res = await api.post('/auth/reset-password', { token, password });
      setSuccess(res.data.message || 'Пароль успешно изменён');
      setTimeout(() => navigate('/login'), 3000);
    } catch (err) {
      setError(err.response?.data?.message || 'Ошибка сброса пароля');
    }
    setLoading(false);
  };

  if (!token) {
    return (
      <div className="auth-container">
        <div className="auth-card">
          <h2>Неверная ссылка</h2>
          <p>Ссылка для сброса пароля некорректна или устарела.</p>
          <button onClick={() => navigate('/login')}>На страницу входа</button>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-logo">
          <img src="/tryndi.png" className="auth-wordmark" alt="Трынди" />
        </div>
        <form onSubmit={handleSubmit}>
          <h2>Сброс пароля</h2>
          {error && <div className="auth-error">{error}</div>}
          {success && <div className="auth-success">{success}</div>}

          <div className="password-wrapper">
            <input type={showPassword ? 'text' : 'password'} placeholder="Новый пароль" value={password}
              onChange={(e) => { setPassword(e.target.value); setError(''); }}
              required minLength={8} />
            <span className="password-toggle" onClick={() => setShowPassword(!showPassword)}>
              {showPassword ? '🙈' : '👁️'}
            </span>
          </div>

          <div className="password-wrapper">
            <input type={showPassword ? 'text' : 'password'} placeholder="Подтвердите пароль" value={confirmPassword}
              onChange={(e) => { setConfirmPassword(e.target.value); setError(''); }}
              required minLength={8} />
          </div>

          {password && (
            <div className={`password-strength ${isStrongPassword(password) ? 'weak' : 'strong'}`}>
              {isStrongPassword(password) || '✓ Надёжный пароль'}
            </div>
          )}

          <button type="submit" disabled={loading}>
            {loading ? 'Загрузка...' : 'Сбросить пароль'}
          </button>
        </form>
      </div>
    </div>
  );
}
